import React from 'react';
import PropTypes from 'prop-types';
import ProductCardInstructions from './ProductCardInstructions';
import ProductCardDocument from './ProductCardDocument';

const ProductCardDetail = ({ ...props }) => {
  const { mobile, category, handleProductSelected } = props;

  return (
    <>
      <ProductCardInstructions mobile={mobile} category={category} />
      <ProductCardDocument
        mobile={mobile}
        handleProductSelected={handleProductSelected}
      />
    </>
  );
};

ProductCardDetail.propTypes = {
  mobile: PropTypes.bool,
  category: PropTypes.object,
  handleProductSelected: PropTypes.func,
};

export default ProductCardDetail;
